import {
  START_LOADING,
  END_LOADING,
  FETCH_TODO_LISTS,
  FETCH_TODO_LIST,
  ADD_TODO_LIST,
  UPDATE_TODO_LIST,
  DELETE_TODO_LIST,
  ADD_TODO_ITEM,
  UPDATE_TODO_ITEM,
  DELETE_TODO_ITEM,
  FETCH_TODO_ITEMS,
  TOGGLE_TODO_ITEM,
  CLEAR_CURRENT_LIST,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  lists: [],
  currentList: null,
  items: [],
  error: null,
  numberOfPages: 0,
};

const todoReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case END_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    case FETCH_TODO_LISTS:
      return {
        ...state,
        lists: action.payload.data || action.payload,
        numberOfPages: action.payload.numberOfPages || 1,
      };

    case FETCH_TODO_LIST:
      return {
        ...state,
        currentList: action.payload,
      };

    case ADD_TODO_LIST:
      return {
        ...state,
        lists: [...state.lists, action.payload],
        currentList: action.payload,
      };

    case UPDATE_TODO_LIST:
      return {
        ...state,
        lists: state.lists.map((list) =>
          list._id === action.payload._id ? action.payload : list
        ),
        currentList:
          state.currentList && state.currentList._id === action.payload._id
            ? action.payload
            : state.currentList,
      };

    case DELETE_TODO_LIST:
      return {
        ...state,
        lists: state.lists.filter((list) => list._id !== action.payload),
        currentList:
          state.currentList && state.currentList._id === action.payload
            ? null
            : state.currentList,
      };

    case FETCH_TODO_ITEMS:
      return {
        ...state,
        items: Array.isArray(action.payload) ? action.payload : [],
      };

    case ADD_TODO_ITEM:
      return {
        ...state,
        items: [...state.items, action.payload],
      };

    case UPDATE_TODO_ITEM:
      return {
        ...state,
        items: state.items.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case TOGGLE_TODO_ITEM:
      return {
        ...state,
        items: state.items.map((item) =>
          item._id === action.payload._id ? action.payload : item
        ),
      };

    case DELETE_TODO_ITEM:
      return {
        ...state,
        items: state.items.filter((item) => item._id !== action.payload),
      };

    case CLEAR_CURRENT_LIST:
      return {
        ...state,
        currentList: null,
        items: [],
      };

    default:
      return state;
  }
};

export default todoReducer;
